export const CURRENT_MAPPING_TEXT = {
    id: 'oe.attendeeMapping.currentMapping',
    description: 'Label text',
    defaultMessage: 'Current mapping'
};

export const ORG_NAME_TEXT = {
    id: 'oe.attendeeMapping.orgName',
    description: 'Column header text',
    defaultMessage: 'Org Name'
};

export const PREFERRED_NAME_TEXT = {
    id: 'oe.attendeeMapping.preferredName',
    description: 'Label text',
    defaultMessage: 'Preferred Name'
};

export const SEARCH_TEXT = {
    id: 'oe.attendeeMapping.search',
    description: 'Button text',
    defaultMessage: 'Search'
};

export const REMOVE_MAPPING_TEXT = {
    id: 'oe.attendeeMapping.removeMapping',
    description: 'Button text',
    defaultMessage: 'Remove'
};

export const CHANGE_MAPPING_TEXT = {
    id: 'oe.attendeeMapping.changeMapping',
    description: 'Button text',
    defaultMessage: 'Change'
};

export const MAPPING_UPDATED_TEXT = {
    id: 'oe.attendeeMapping.mappingUpdated',
    description: 'Notification about updated attendee mapping',
    defaultMessage: 'Attendee mapping updated'
};

export const NO_CONTACTS_FOUND_TEXT = {
    id: 'oe.attendeeMapping.noContactsFound',
    description: 'Label text',
    defaultMessage: 'No contacts matching search criteria.'
};

